/**
 * Daily-stats hook (Spec 469) — pure read hook for the dashboard widget.
 *
 * D7: staleTime 120s, NO refetchInterval — every fetch costs the BFF 15–70
 * Facade calls, so freshness comes from remount + focus refetches. App.tsx
 * disables refetchOnWindowFocus globally, so it is re-enabled per-query here;
 * without it an idle tab would never roll past midnight. The 120s stale
 * window dampens focus refetches by itself.
 */
import { useQuery } from '@tanstack/react-query';
import { getDailyStats } from '@/lib/api/dashboard-stats';

/** The owner parameter N — window size in days (Spec 469: start at 3). */
export const DAILY_STATS_DAYS = 3;

export const dailyStatsKeys = {
  all: ['daily-stats'] as const,
  stats: (days: number) => [...dailyStatsKeys.all, days] as const,
};

export function useDailyStats(days = DAILY_STATS_DAYS) {
  return useQuery({
    queryKey: dailyStatsKeys.stats(days),
    queryFn: () => getDailyStats(days),
    staleTime: 120_000,
    refetchOnWindowFocus: true,
  });
}
